import { createAuthInstance, createXSRFInstance } from 'axios-interceptor'

export default {
  namespaced: true,

  state: {
    required: [],
    extras: [],
    reminders: '0'
  },

  mutations: {
    setRequired (state, required) {
      state.required = required
    },
    setExtras (state, extras) {
      state.extras = extras
    },
    setReminders (state, reminders) {
      state.reminders = reminders
    }
  },

  actions: {
    fetchProgress (context, { providerID, adminRequest }) {
      const axios = createAuthInstance(context, createXSRFInstance())
      return axios({
        method: 'get',
        url: `/api/progress?id=${providerID}&admin=${adminRequest}`
      }).then(({ data }) => {
        context.commit('setRequired', data.data.apps)
        context.commit('setExtras', data.data.extras)
        context.commit('setReminders', data.data.reminders)
        return data
      })
    }
  }
}
